/**
 * Seznam.cz Retargeting Utility
 * Dynamicky načte Seznam.cz retargeting script pouze po získání souhlasu
 */

/**
 * Načte Seznam.cz retargeting script a spustí retargeting hit
 * @param {boolean} hasConsent - Zda uživatel souhlasil s cookies (true/false)
 * @param {string|null} emailHash - Zahashovaný email uživatele (volitelné)
 */
export const loadSeznamRetargeting = (hasConsent, emailHash = null) => {
  // Bez souhlasu script vůbec nenačítáme
  if (!hasConsent) {
    console.log('Seznam.cz retargeting: souhlas odmítnut, script nenačten');
    return;
  }

  // Kontrola, zda již není script načten
  if (document.getElementById('seznam-retargeting-script')) {
    console.log('Seznam.cz retargeting script je již načten');
    return;
  }

  // Načtení rc.js scriptu
  const script = document.createElement('script');
  script.id = 'seznam-retargeting-script';
  script.type = 'text/javascript';
  script.src = 'https://c.seznam.cz/js/rc.js';
  script.async = true;

  script.onload = () => {
    // Po načtení scriptu spustíme retargeting hit
    if (window.sznIVA && window.rc) {
      try {
        // Update identities (email hash)
        window.sznIVA.IS.updateIdentities({
          eid: emailHash // null nebo zahashovaný email
        });

        // Retargeting configuration
        const retargetingConf = {
          rtgId: 1653473, // Vaše rtgId
          consent: hasConsent ? 1 : 0 // 1 = souhlas, 0 = bez souhlasu
        };

        // Spuštění retargeting hitu
        window.rc.retargetingHit(retargetingConf);

        console.log('Seznam.cz retargeting hit odeslán s consent:', hasConsent ? 1 : 0);
      } catch (error) {
        console.error('Chyba při spouštění Seznam.cz retargeting:', error);
      }
    }
  };

  script.onerror = () => {
    console.error('Nepodařilo se načíst Seznam.cz retargeting script');
  };

  // Přidání scriptu do stránky
  document.head.appendChild(script);
};

/**
 * Odstraní Seznam.cz retargeting script ze stránky
 */
export const removeSeznamRetargeting = () => {
  const script = document.getElementById('seznam-retargeting-script');
  if (script) {
    script.remove();
    console.log('Seznam.cz retargeting script byl odstraněn');
  }
};
